import { gql } from '@lichtblick/apollo';

export const GET_APPOINTMENTS = gql`
  query getAppointments_V1(
    $notBeforeUtc: DateTime
    $notAfterUtc: DateTime
    $branch: Int
    $team: Int
    $query: String
    $appointmentType: [String!]
    $page: PageInput
    $orderBy: [SortDescriptionInput!]
  ) {
    getAppointments_V1(
      input: {
        notBeforeUtc: $notBeforeUtc
        notAfterUtc: $notAfterUtc
        branchOfficeId: $branch
        teamId: $team
        search: $query
        workflowDefinitions: $appointmentType
        isBinding: true
        page: $page
        onlyReturnMyAssginedAppointments: false
        orderBy: $orderBy
      }
    ) {
      totalItems
      error
      data {
        id
        type
        status
        startDateUtc
        endDateUtc
        expectedDuration
        startScreenInformation
        isBinding
        constructedByTeams {
          id
          team {
            id
            name
          }
        }
        constructedByCraftsmen {
          id
          craftsman {
            id
            firstName
            lastName
          }
        }
        workOrder {
          id
          eaasId
          name
          approvalState
          numberOfSubmitted
          numberOfResubmitted
          modifiedAtUtc
          readOnlyAddress {
            id
            isReadOnly
            street
            number
            zipCode
            city
          }
        }
      }
    }
  }
`;

export const UNASSIGN_USER_FROM_APPOINTMENT = gql`
  mutation UnassignUserFromAppointment($appointmentId: Int!, $userId: Int!) {
    unassignUserFromAppointment_V1(input: { appointmentId: $appointmentId, userId: $userId }) {
      error
    }
  }
`;

export const GET_APPOINTMENT_WORKFORCE = gql`
  query GetAppointmentWorkforce_V1($appointmentId: Int!) {
    getAppointmentWorkforce_V1(input: { appointmentId: $appointmentId }) {
      error
      data {
        craftsmen {
          id
          eMail
          firstName
          lastName
          defaultTeamId
        }
        teams {
          id
          name
          isDeleted
          branchOffice {
            id
            name
          }
        }
      }
    }
  }
`;

export const ATTACH_USER_TO_APPOINTMENT = gql`
  mutation AttachUserToAppointment_V1($appointmentId: Int!, $userIds: [Int!]!) {
    attachUserToAppointment_V1(input: { appointmentId: $appointmentId, userIds: $userIds }) {
      data {
        assignments {
          userId
          assignment
        }
      }
      error
    }
  }
`;

export const ATTACH_TEAM_TO_APPOINTMENT = gql`
  mutation AttachTeamToAppointment_V1($input: AttachTeamToAppointmentInput!) {
    attachTeamToAppointment_V1(input: $input) {
      data {
        users {
          id
        }
      }
      error
    }
  }
`;

export const UNASSIGN_TEAM_FROM_APPOINTMENT = gql`
  mutation UnassignTeamFromAppointment($input: UnassignTeamFromAppointmentInput!) {
    unassignTeamFromAppointment_V1(input: $input) {
      error
    }
  }
`;

export const GET_USERS = gql`
  query GetUsers_V1($roleId: Int, $search: String, $page: PageInput) {
    getUsers_V1(input: { roleId: $roleId, search: $search, page: $page, includeDeleted: true }) {
      error
      data {
        jobTitle
        id
        isDeleted
        firstName
        lastName
        roles {
          id
          name
        }
        employer {
          name
          id
        }
        eMail
      }
    }
  }
`;

export const GET_APPOINTMENT = gql`
  query getAppointment_V1($input: GetAppointmentInput!) {
    getAppointment_V1(input: $input) {
      error
      data {
        appointment {
          isBinding
          comment
          id
          type
          status
          startDateUtc
          endDateUtc
          expectedDuration
          startScreenInformation
          workOrder {
            id
            eaasId
            name
          }
          constructedByTeams {
            id
            team {
              id
              name
            }
          }
          constructedByCraftsmen {
            id
            craftsman {
              id
              eMail
              firstName
              lastName
            }
          }
          workflowDefinition {
            id
            name
          }
          branchOffice {
            id
          }
          partnerCompanies {
            id
            name
          }
        }
      }
    }
  }
`;

export const SCHEDULE_APPOINTMENT = gql`
  mutation scheduleAppointment_V1($input: ScheduleAppointmentInput!) {
    scheduleAppointment_V1(input: $input) {
      error
      data {
        id
      }
    }
  }
`;

export const CREATE_APPOINTMENT_CALENDAR = gql`
  mutation postAppointment_V1($input: PostAppointmentInput!) {
    postAppointment_V1(input: $input) {
      error
      data {
        id
        startAtUtc
        endAtUtc
        isBinding
        teams {
          id
          name
        }
        workOrder {
          id
          name
        }
        workflowDefinition {
          id
          name
        }
      }
    }
  }
`;

export const UPDATE_APPOINTMENT_CALENDAR = gql`
  mutation patchAppointmentComposite_V1($input: PatchAppointmentCompositeInput!) {
    patchAppointmentComposite_V1(input: $input) {
      error
    }
  }
`;

export const CREATE_BLOCKER_CALENDAR = gql`
  mutation postBlocker_V1($input: PostBlockerInput!) {
    postBlocker_V1(input: $input) {
      error
      data {
        id
        startAtUtc
        endAtUtc
        reason {
          id
          title
        }
      }
    }
  }
`;

export const UPDATE_BLOCKER_CALENDAR = gql`
  mutation patchBlocker_V1($input: PatchBlockerInput!) {
    patchBlocker_V1(input: $input) {
      error
      data {
        id
        startAtUtc
        endAtUtc
        reason {
          id
          title
        }
      }
    }
  }
`;

export const GET_BLOCKER = gql`
  query getBlocker_V1($input: GetBlockerInput!) {
    getBlocker_V1(input: $input) {
      error
      data {
        branchOffice {
          id
        }
        comment
        endAtUtc
        id
        reason {
          id
          title
        }
        startAtUtc
        teams {
          id
          name
        }
        users {
          id
          firstName
          lastName
        }
        partnerCompanies {
          id
          name
        }
      }
    }
  }
`;

export const GET_CALENDAR_ITEMS = gql`
  query getCalendarItems_V1($input: GetCalendarItemsInput!) {
    getCalendarItems_V1(input: $input) {
      totalItems
      data {
        ... on BlockerCalendarItemPayloadModel {
          id
          startAtUtc
          endAtUtc
          users {
            id
            eMail
            firstName
            lastName
          }
          teams {
            id
            name
          }
          reason {
            id
            title
          }
          branchOffice {
            id
            name
            isDeleted
          }
          partnerCompanies {
            id
            name
          }
        }
        ... on AppointmentCalendarItemPayloadModel {
          startAtUtc
          endAtUtc
          id
          isBinding
          teams {
            id
            name
          }
          users {
            id
            eMail
            firstName
            lastName
          }
          partnerCompanies {
            id
            name
          }
          workOrder {
            id
            name
            approvalState
            numberOfSubmitted
            numberOfResubmitted
            modifiedAtUtc
            numberOfBlockedFields
          }
          workflowDefinition {
            id
            name
          }
          branchOffice {
            id
            name
            isDeleted
          }
        }
      }
    }
  }
`;

export const GET_CRAFT_COMPANIES = gql`
  query GetCraftCompanies_V1($input: GetCraftCompaniesInput) {
    getCraftCompanies_V1(input: $input) {
      totalItems
      error
      data {
        name
        id
      }
    }
  }
`;

export const GET_ORDERS_FOR_APPOINTMENTS = gql`
  query getWorkOrders_V1_PM($input: GetWorkOrdersInput) {
    getWorkOrders_V1(input: $input) {
      totalItems
      data {
        id
        eaasId
        qualityManager {
          id
          firstName
          lastName
        }
        modifiedAtUtc
        customers {
          id
          customer {
            name
          }
        }
        name
        paused
        status
        approvalState
        branchOffice {
          id
          name
        }
        product {
          id
          name
        }
      }
    }
  }
`;

export const DELETE_APPOINTMENT_CALENDAR = gql`
  mutation deleteAppointment_V1($input: DeleteAppointmentInput!) {
    deleteAppointment_V1(input: $input) {
      error
    }
  }
`;

export const DELETE_BLOCKER_CALENDAR = gql`
  mutation deleteBlocker_V1($input: DeleteBlockerInput!) {
    deleteBlocker_V1(input: $input) {
      error
    }
  }
`;
